module.exports = __webpack_public_path__ + "images/emoji/five.1227c8b201ea27ce9888.png";